// extracted by mini-css-extract-plugin
export default {"main-nav":"xspzoQkkE1_Mdg8A1pKe","active":"MP1S6FuSohayRXuEdsrZ"};